import dayjs from 'dayjs';

export type DragMode = 'move' | 'start' | 'end';

/**
 * Wendet eine Tages-Verschiebung auf ein Balken-Intervall an — gemeinsame Logik
 * fuer beide Gantts (AP-Balken im Gesamt-Gantt, Task-Balken im AP-Gantt).
 *
 * - 'move'  : verschiebt Start und Ende um dayDelta (Balken wandert).
 * - 'start' : zieht nur die linke Kante; Start darf nicht hinter das Ende rutschen.
 * - 'end'   : zieht nur die rechte Kante; Ende darf nicht vor den Start rutschen.
 *
 * Rueckgabe sind reine Datums-Strings ('YYYY-MM-DD'); die API-datetime-Konvertierung
 * passiert erst beim Persistieren (toApiDatetime).
 */
export function applyDayDelta(
  start: string,
  end: string,
  mode: DragMode,
  dayDelta: number,
): { start: string; end: string } {
  const s = dayjs(start);
  const e = dayjs(end);
  const fmt = (d: dayjs.Dayjs) => d.format('YYYY-MM-DD');

  if (mode === 'move') {
    return { start: fmt(s.add(dayDelta, 'day')), end: fmt(e.add(dayDelta, 'day')) };
  }
  if (mode === 'start') {
    const ns = s.add(dayDelta, 'day');
    return { start: fmt(ns.isAfter(e) ? e : ns), end };
  }
  // 'end'
  const ne = e.add(dayDelta, 'day');
  return { start, end: fmt(ne.isBefore(s) ? s : ne) };
}

/**
 * Pixel-Verschiebung in eine ganzzahlige Tages-Verschiebung umrechnen.
 * pxPerDay = Trackbreite / Anzahl Tage der Zeitachse.
 */
export function pxToDayDelta(pxDelta: number, pxPerDay: number): number {
  if (!pxPerDay || !isFinite(pxPerDay)) return 0;
  return Math.round(pxDelta / pxPerDay);
}
